
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useRef, useState } from 'react';
import classNames from "classnames";
const FunctionalityItem = ({ item, activeItem, setActiveItem, cb }) => {
    return <li className={classNames({
            "functionality_items_item": true,
            "active": +item.key === activeItem
        })} onClick={() => {
            cb();
            setActiveItem(+item.key);
        }}>
        <span className={'item_index'}>{item.key}</span>
        <h3 className={'item_title'}>{item.title}</h3>
    </li>;
};
const WalletFunctionality = ({ t }) => {
    const functionality = t('coldware_wallet:functionality', {}, { returnObjects: true });
    const [activeItem, setActiveItem] = useState(1);
    let intervalRef = useRef(null);
    const randomizeActiveItem = () => {
        intervalRef.current = setInterval(() => {
            setActiveItem(prevCount => {
                if (prevCount === 4) {
                    return 1;
                }
                else {
                    return +prevCount + 1;
                }
            });
        }, 4000);
    };
    useEffect(() => {
        randomizeActiveItem();
        return () => clearInterval(intervalRef.current);
    }, []);
    return (<section className={'functionality'}>
            <div className="container">
                <div className="functionality_wrapper">
                    <ul className={'functionality_items'}>
                        {functionality.items.map(item => {
            return <FunctionalityItem key={item.key} item={item} cb={() => clearInterval(intervalRef.current)} setActiveItem={setActiveItem} activeItem={activeItem}/>;
        })}
                    </ul>
                    <div className={'functionality_media'}>
                        <picture>
                            <source media="(max-width: 768px)" srcSet={`/img/pages/ecosystem/cold_wallet/functionality/func_${activeItem}_small.webp`} type="image/webp"/>
                            <source media="(min-width: 769px)" srcSet={`/img/pages/ecosystem/cold_wallet/functionality/func_${activeItem}.webp`} type="image/webp"/>
                            <source media="(max-width: 768px)" srcSet={`/img/pages/ecosystem/cold_wallet/functionality/func_${activeItem}_small.png`}/>
                            <source media="(min-width: 769px)" srcSet={`/img/pages/ecosystem/cold_wallet/functionality/func_${activeItem}.png`}/>
                            <img src={`/img/pages/ecosystem/cold_wallet/functionality/func_${activeItem}.png`} alt={`ColdWare Wallet`} width={380} height={380} className='functionality_media_img'/>
                        </picture>
                    </div>
                </div>
            </div>
        </section>);
};
export default WalletFunctionality;

    async function __Next_Translate__getStaticProps__196111dc4a7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//ecosystem/wallet/Functionality/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196111dc4a7__ as getStaticProps }
  